export class FilterFieldValue {
    FieldName: string;
    Value: string[];
    //ValueStr: string;
}

export class WidgetFieldValue {
  FieldName: string;
  Value: string;
}

export class QueryParams {
    QueryId: Number;
    FilterFields: FilterFieldValue[];
}


export class ApplyDunningParams {
    DocEntries: Number[];
    Level: Number;
    SendRealSMS: boolean;
}


export class SubScriptionLine {
    docEntry: number;
    paidAmount: number;
    paymentMethod: string;
    thereIsFirstInvoice: boolean;
    mnthEnd: boolean;
    numMonth: number;
    docDueDate: Date;

    constructor() {
    }
}

export class SubScriptionInvoicingParams {
    SubScriptionLines: SubScriptionLine[];
    SYear: string;
    SMonth: string;

    constructor() {
    }
}

export class PrintingInvoicesParams {
    BatchNos: string[];

    constructor() {
    }
}

export class PrintingContractsParams {
    OrderEntries: Number[];

    constructor() {
    }
}

export class SendReminderParams {
    CardName: string;
    DocNum: string;
    DocEntry: string;
    CustomerMobile: string;

    constructor() {
    }
}
